export default "/images/4c36968336cf80f4c7ceaaee7d0cd39a.avif";